export const USER_LOADED = 'USER_LOADED'
export const COUNT_LOADED = 'COUNT_LOADED'
export const LOGOUT = 'LOGOUT'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const CALL_END = 'CALL_END'
